import { useState } from "react";
import { X, Play } from "lucide-react";
import { CODING_LANGS } from "./CodingRoundSection";

// Mirrors the candidate Coding Room layout: problem on the left, editor on the right.
export default function ProblemPreview({ problem, langs, onClose }) {
  const [lang, setLang] = useState(langs[0]);
  return (
    <div className="fixed inset-0 z-[60] bg-black/70 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} data-testid="coding-preview-modal"
        className="w-full max-w-5xl max-h-[88vh] overflow-hidden rounded-xl bg-[#0b1020] text-slate-100 border border-white/10 flex flex-col">
        <div className="flex items-center justify-between px-4 py-2.5 border-b border-white/10">
          <div className="text-xs uppercase tracking-wider text-slate-400">Candidate preview · Live Coding</div>
          <button type="button" data-testid="coding-preview-close" onClick={onClose} className="text-slate-400 hover:text-white"><X className="w-4 h-4" /></button>
        </div>
        <div className="grid md:grid-cols-2 flex-1 min-h-0">
          <div className="p-5 overflow-y-auto border-r border-white/10">
            <h3 className="font-display text-xl font-semibold mb-3">{problem.title}</h3>
            <p className="text-sm text-slate-300 whitespace-pre-wrap leading-relaxed">{problem.description}</p>
            {(problem.examples || []).map((ex, i) => (
              <div key={i} className="mt-4 rounded-lg bg-white/5 border border-white/10 p-3 text-xs font-mono">
                <div className="text-slate-400 mb-1">Example {i + 1}</div>
                <div className="whitespace-pre-wrap break-words"><span className="text-slate-500">Input: </span>{ex.input}</div>
                <div className="whitespace-pre-wrap break-words mt-1"><span className="text-slate-500">Output: </span>{ex.output}</div>
              </div>
            ))}
          </div>
          <div className="flex flex-col min-h-0">
            <div className="flex items-center gap-2 px-3 py-2 border-b border-white/10">
              <select data-testid="coding-preview-lang" value={lang} onChange={(e) => setLang(e.target.value)} className="tp-select text-xs px-2 py-1 rounded bg-white/5 border border-white/10">
                {langs.map(l => <option key={l} value={l}>{CODING_LANGS.find(c => c.key === l)?.label || l}</option>)}
              </select>
              <span className="ml-auto inline-flex items-center gap-1 text-xs px-2.5 py-1 rounded bg-emerald-600/80 text-white opacity-70"><Play className="w-3 h-3" /> Run</span>
            </div>
            <pre className="flex-1 overflow-auto p-4 text-xs font-mono text-slate-200 whitespace-pre">{problem.starter?.[lang] || ""}</pre>
          </div>
        </div>
      </div>
    </div>
  );
}
